export default function MyClaims() {
  return (
    <div>
      <h2>My Claims</h2>
      <p>This page is under development</p>
    </div>
  );
}